import React, { useContext, useEffect, useState } from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import Navigation from '../../../layout/Navigation/Navigation';
import useDeviceScreen from '../../../hooks/useDeviceScreen';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import AuthContext from '../../../contexts/authContext';
import ThemeContext from '../../../contexts/themeContext';
import Button from '../../../components/bootstrap/Button';
import Icon from '../../../components/icon/Icon';
import HeaderContext from '../../../common/components/HeaderContext';

const DefaultHeader = () => {

	const { width } = useDeviceScreen();
	const { mobileDesign } = useContext(ThemeContext);
	const { darkModeStatus } = useDarkMode();
	const { userTypeId, userAccountId, userData } = useContext(AuthContext);

	return (
		mobileDesign ?
			<Header>
				<HeaderLeft>

					<div className='d-flex align-items-center'>
						<div className='row g-4'>
							<div className='col-md-auto'>
								<div
									className={classNames('fs-3', 'fw-bold', {
										'text-dark': !darkModeStatus,
									})}>
									Hi, {userData.userName}!
								</div>
							</div>
						</div>
					</div>
				</HeaderLeft>
			</Header> : <></>
	);
};

export default DefaultHeader;
